import React__default, { useState, useCallback } from 'react';
import { Snackbar } from '@material-ui/core';
import { Builds as Builds$1 } from './lib/Builds/Builds.esm.js';
import { Alert } from '@material-ui/lab';
import { ContentHeader, SupportButton } from '@backstage/core-components';

const Builds = () => {
  const [restarted, setRestarted] = useState(false);
  const handleRestart = useCallback(() => {
    setRestarted(true);
  }, [setRestarted]);
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    Snackbar,
    {
      autoHideDuration: 1e3,
      open: restarted,
      anchorOrigin: { vertical: "top", horizontal: "center" },
      onClose: () => setRestarted(false)
    },
    /* @__PURE__ */ React__default.createElement(Alert, { severity: "success" }, "Build Restarted.")
  ), /* @__PURE__ */ React__default.createElement(ContentHeader, { title: "All builds" }, /* @__PURE__ */ React__default.createElement(SupportButton, null, "This plugin allows you to view and interact with your builds within the Travis CI environment.")), /* @__PURE__ */ React__default.createElement(Builds$1, { onRestart: handleRestart }));
};

export { Builds };
//# sourceMappingURL=BuildsPage.esm.js.map
